import { BaseApiService } from "../../../../base/base-api.service";
import { SkillLevelDTO } from "../../../../../models/recruiting/candidate/skills/skill-level/skill-level-dto";
import { SkillLevelSTO } from "../../../../../models/recruiting/candidate/skills/skill-level/skill-level-sto";

export class SkillLevelsApiService extends BaseApiService<SkillLevelDTO, SkillLevelSTO> {
  constructor() {
    super({
      servicePath: "/Skills",
      loadItemsPath: "/GetSkillLevels",
    });
  }
}
